import ajax from "./ajax";

// Get all job categories

export const getCategories = (params = "") => {
  return ajax(`/JobCategory/categories${params}`);
};
export const getJobCategories = (params = "") => {
  return ajax(`/GernalCategory/getAllGernalCategory${params}`);
};
export const getJobIndustries = (params = "") => {
  return ajax(`/JobType${params}`);
};
